module.exports = __webpack_public_path__ + "img/visual-data-animate.ecfbfcdc.svg";